import { render, staticRenderFns } from "./ChallengeCourseEquipe.vue?vue&type=template&id=37a3d144&scoped=true"
import script from "./ChallengeCourseEquipe.vue?vue&type=script&lang=js"
export * from "./ChallengeCourseEquipe.vue?vue&type=script&lang=js"
import style0 from "./ChallengeCourseEquipe.vue?vue&type=style&index=0&id=37a3d144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3d144",
  null
  
)

export default component.exports